// react
import React, { Component, PropTypes } from "react"
//material-ui
import MUIDatePicker from "material-ui/DatePicker"


class DatePicker extends Component {
    constructor(props) {
        super(props)

        this.state = {
            errorText: "",
            value: (props.value) ? (this.fromPhpDate(props.value)) : (null)
        }

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(e, value) {
        if (this.props.mandatory && value === "") {
            this.setState({
                errorText: "This field is required"
            })
            if (this.props.onError) this.props.onError(true)
        } else {
            this.setState({
                errorText: "",
                value
            })

            if (this.props.onError) this.props.onError(false)
            if (this.props.onChange) this.props.onChange(this.toPhpDate(value))
        }
    }

    fromPhpDate(str) {
        const date = str.split("-")
        return new Date(date[0], date[1] - 1, date[2])
    }

    toPhpDate(date) {
        let str = date.getFullYear() + "-"
        str += ("0" + (date.getMonth() + 1)).slice(-2) + "-"
        str += ("0" + date.getDate()).slice(-2)
        return str
    }

    render() {
        const label = this.props.label + ((this.props.mandatory)?("*"):(""))

        return (
            <MUIDatePicker
                value={ this.state.value }
                floatingLabelText={ label }
                errorText={ this.state.errorText }
                onChange={ this.handleChange }
                fullWidth={ true }
                disabled={ this.props.disabled }
            />
        )
    }
}

DatePicker.propTypes = {
    mandatory: PropTypes.bool,
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onError: PropTypes.func
}

export default DatePicker


/** WEBPACK FOOTER **
 ** ./src/components/common/DatePicker/date-picker.js
 **/